import type { SlideHighlightState } from "../types.d";

export class HighlightController {
  private _contentEl?: HTMLElement;
  set contentEl(el: HTMLElement) {
    this._contentEl = el;
  }
  private _initAnimation = false;
  update({ shown = [], hidden = [] }: SlideHighlightState) {
    setTimeout(() => (this._initAnimation = true), 50);
    if (!this._contentEl) return;
    shown.forEach((highlightId) => {
      const highlightEl = this._contentEl?.querySelector(
        `[data-id="${highlightId}"]`,
      );
      highlightEl?.setAttribute("show", "");
      if (this._initAnimation) {
        highlightEl?.removeAttribute("no-animation");
      } else {
        highlightEl?.setAttribute("no-animation", "");
      }
    });
    hidden.forEach((highlightId) => {
      const highlightEl = this._contentEl?.querySelector(
        `[data-id="${highlightId}"]`,
      );
      highlightEl?.removeAttribute("show");
      if (this._initAnimation) {
        highlightEl?.removeAttribute("no-animation");
      } else {
        highlightEl?.setAttribute("no-animation", "");
      }
    });
  }
}
